<template>
    <div>
        <header class="justify-between">
            <h1 class="h5 mb-0">
                {{ $t('Elements') }}
            </h1>

            <b-button-group>
                <b-button
                    :disabled="pending"
                    @click="fetchData"
                >
                    <fa :spin="pending" icon="sync" />
                </b-button>
            </b-button-group>
        </header>


        <div role="tablist">
            <b-card
                v-for="wall in items"
                :key="`wall_${wall.id}`"
                no-body
            >
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button
                        v-b-toggle="`wall_${wall.id}_collapse`"
                        block
                        variant="default"
                        class="text-left"
                    >
                        {{ wall.name }} ({{ wall.elements.length }})
                    </b-button>
                </b-card-header>

                <b-collapse
                    :id="`wall_${wall.id}_collapse`"
                    v-model="wallCollapse[wall.id]"
                    accordion="roomElementsAccordion"
                    role="tabpanel"
                >
                        <wall-elements-item
                            v-for="(element, index) in wall.elements"
                            :key="`room_${roomId}_element_${element.id}_item`"
                            v-model="wall.elements[index].info"
                            :api-url="`/api/walls/${wall.id}/elements/${element.id}`"
                            :element="element"
                            :element-type="element.type"
                            :title="element.toString"
                            class="mb-3"
                            @deleted="wall.elements.splice(index, 1)"
                        />
                </b-collapse>
            </b-card>
        </div>

        <b-card-body v-if="pending" class="text-center">
            <b-spinner small />
        </b-card-body>

        <b-alert v-if="!pending && !items.length" show variant="info" class="m-0">
            {{ $t('No results found') }}
        </b-alert>
    </div>
</template>

<script>
    import fetchData from '@/mixins/fetchData';
    import WallElementsItem from "@/components/walls/WallElementsItem";

    export default {
        name: 'RoomElements',
        components: {WallElementsItem},
        mixins: [fetchData],
        props: {
            roomId: {
                type: [String, Number],
                required: true,
            },
        },

        data() {
            return {
                wallCollapse: {}
            }
        },

        computed: {
            apiUrl() {
                return `/api/rooms/${this.roomId}/elements`;
            },
        },

        created() {
            let _this = this;
            this.$root.$on('disabilities-assigned', function (data) {
                _this.fetchData();
            })
        },
    };
</script>

<style lang="scss" scoped>
    @import 'resources/sass/variables';

    .card {
        margin-top: $spacer * 0.5;
    }

    .card .card {
        margin-left:  $spacer * 0.5;
        margin-right: $card-border-width * -1;
    }
</style>
